export const environment = {
  production: false,
  apiRootUrl: 'https://yeq7szw1ak.execute-api.us-east-1.amazonaws.com/dev',
  webSocketRootUrl: 'wss://svwjf0x5u5.execute-api.us-east-1.amazonaws.com/dev'
};
